



// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Mixins } from 'vue-mixin-decorator';
import { mapGetters, mapActions } from 'vuex';

// Third party
import dayjs, { UnitType } from 'dayjs';
import 'dayjs/locale/es';

// Constants
import Assets from '@/constants/assets.ts';

// Components
import Btn, { BtnColor, BtnWidth } from '@/shared/components/btn.component.vue';
import Datepicker, { DatepickerBorder } from '@/shared/components/datepicker/index.vue';
import DropUp, { DropUpColorHover } from '@/shared/components/DropUp.component.vue';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';
import Pagination from '@/shared/components/Pagination/Pagination.component.vue';
import ItemThumb from '@/shared/components/item-thumb.component.vue';
import Spinner from '@/shared/components/Spinner.component.vue';
import TableColumnOrder from '@/shared/components/TableColumnOrder.component.vue';
import Dropdown, { DropdownWidth } from '@/shared/components/Dropdown.component.vue';
import TopBar from '@/shared/components/TopBar.component.vue';
import Search, { SearchPredefinedStyle } from '@/shared/components/search.component.vue';
import EmptyState from '@/shared/components/empty-state.component.vue';
import SpotlightText from '@/shared/components/SpotlightText.component.vue';
import Modal, { ModalTitleColor } from '@/shared/components/Modal.component.vue';

// Components - Views
import BillRow from '@/manager/billing/views/bill-row/index.vue';
import EditBillModal from '@/manager/billing/views/edit-bill-modal/index.vue';

// Models - Interfaces
import { Convocation } from '@/manager/convocation/convocation.model';
import { SecondLevelOptionModel } from '@/shared/models/secondLevelOption.model';
import { TimetablesInterface } from '@/shared/interfaces/timetables.interface';
import { Purchase } from '@/clickbuy/purchase/models/purchase.model';
import Bill, { TransactionType } from '@/manager/billing/models/bill.model';

// Services
import BillingService from '@/manager/billing/billing.service';
import UtilsService from '@/core/services/utils.service';

// Mixins
import WithSpinner from '@/shared/mixins/withSpinner.mixin.ts';
import WithPagination from '@/shared/mixins/withPagination.mixin.ts';
import ColumnOrderMixin from '@/shared/mixins/columnOrder.mixin.ts';
import NotificationMessage from '@/shared/mixins/notificationMessage.mixin.ts';
import SearchMixin from '@/shared/mixins/search.mixin.ts';

import FlatSelectorText, {
    FlatSelectorTextPredefinedStyle,
    FlatSelectorTextBorderBottom,
    FlatSelectorTextWeight,
} from '@/shared/components/FlatSelectorText.component.vue';

export enum ListActions {
    DownloadCsv = 'download-csv',
    DownloadBillZip = 'download-bill-zip',
    SendAllBills = 'send-all-bills',
    RegeneratePdf = 'regenerate-bill-pdfs'
}

interface MixinInterface extends WithPagination, SearchMixin, NotificationMessage, ColumnOrderMixin {}

@Component({
    components: {
        EditBillModal,
        Btn,
        BillRow,
        Datepicker,
        DropUp,
        Dropdown,
        EmptyState,
        Icon,
        ItemThumb,
        Modal,
        Pagination,
        Spinner,
        TableColumnOrder,
        FlatSelectorText,
        TopBar,
        Search,
        SpotlightText,
    },
    methods: {
        ...mapActions({
            setBillList: 'setBillList',
        }),
    },
    computed: {
        ...mapGetters({
            getBillList: 'getBillList',
            internalBusinessList: 'getInternalBusinessList',
        }),
    },
})
export default class BillList extends Mixins<MixinInterface> (
    WithPagination,
    SearchMixin,
    NotificationMessage,
    ColumnOrderMixin,
) {
    @Prop() private clientBillsList!: string;

    private assets = Assets;
    private dropUpColorHover = DropUpColorHover;
    private iconEnum = IconEnum;
    private btnColor = BtnColor;
    private btnWidth = BtnWidth;
    private dropdownWidth = DropdownWidth;
    private datepickerBorder = DatepickerBorder;
    private searchPredefinedStyle = SearchPredefinedStyle;
    private modalTitleColor = ModalTitleColor;
    private getBillList!: any;
    private participantMassiveEmailList!: any;
    private loadingGroupFilters = true;
    private addBillModalOpened = false;
    private lastNoteTyped: string = '';
    private interval!: any;
    private cleanSearch = false;
    private billListLoaded = false;
    private alertDisplace = false;
    private editBillModalOpened = false;
    private modifyDataPrivateModal = false;
    private setBillList !: Bill[];
    private remittanceModalOpened = false;
    private dateFrom = null;
    private searchInternalBusiness = '';
    private searchSerie = "";
    private searchFiscalData = "";
    protected searchNifString = '';
    private dateTo = null;
    private transactionTypeSelected = this.transactionTypeOptions[0];
    private flatSelectorTextPredefinedStyle = FlatSelectorTextPredefinedStyle;
    private flatSelectorTextBorderBottom = FlatSelectorTextBorderBottom;
    private flatSelectorTextWeight = FlatSelectorTextWeight;
    public seriesList = [
        {'name': 'VO/', 'id': 'VO/'},
        {'name': 'R.VO/', 'id': 'R.VO/'},
        {'name': 'ASECOURSE/', 'id': 'ASECOURSE/'},
        {'name': 'R.ASECOURSE/', 'id': 'R.ASECOURSE/'},
        // {'name': 'ASECONF/', 'id': 'ASECONF/'},
        // {'name': 'R.ASECONF/', 'id': 'R.ASECONF/'},  
        // {'name': 'ASEE/', 'id': 'ASEE/'}, 
        {'name': 'CONF/', 'id': 'CONF/'}, 
        {'name': 'R.CONF/', 'id': 'R.CONF/'}, 
        {'name': 'COURSE/', 'id': 'COURSE/'}, 
        {'name': 'R.COURSE/', 'id': 'R.COURSE/'}, 
        // {'name': 'E/', 'id': 'E/'}, 
        // {'name': 'D/', 'id': 'D/'},
        // {'name': 'R.ASEE/', 'id': 'R.ASEE/'}, 
        // {'name': 'R.E/', 'id': 'R.E/'}, 
        // {'name': 'R.D/', 'id': 'R.D/'}
        { 'name': 'GRUP/', 'id': 'GRUP/' },
        { 'name': 'R.GRUP/', 'id': 'R.GRUP/' },
        { 'name': 'IVGRUP/', 'id': 'IVGRUP/' },
        { 'name': 'R.IVGRUP/', 'id': 'R.IVGRUP/' },
        { 'name': 'CUBX/', 'id': 'CUBX/' },
        { 'name': 'R.CUBX/', 'id': 'R.CUBX/' },
        { 'name': 'IVCUBX/', 'id': 'IVCUBX/' },
        { 'name': 'R.IVCUBX/', 'id': 'R.IVCUBX/' },
        { 'name': 'M/', 'id': 'M/' },
        { 'name': 'R.M/', 'id': 'R.M/' },
        { 'name': 'REF/', 'id': 'REF/' },
        { 'name': 'R.REF/', 'id': 'R.REF/' },
        { 'name': 'FUND/', 'id': 'FUND/' },
        { 'name': 'R.FUND/', 'id': 'R.FUND/' },
        { 'name': 'T/', 'id': 'T/' },
        { 'name': 'R.T/', 'id': 'R.T/' },
    ]
    // public businessList = [{'name': 'LEVEL UP DESARROLLO PROFESIONAL, S.L.U.', 'id': '4'}, {'name': 'ASESORAMIENTO A EMPRESAS LEVEL UP, S.L.', 'id': '5'}, {'name': 'GESTIÓN INTERNA', 'id': '6'}, {'name': 'TLP ANTIGÜO', 'id': '7'}, {'name': 'Todas las empresas', 'id': ''}]
    public internalBusinessList !: any
    private showBusiness = false;
    protected searchString:any = new URLSearchParams(window.location.href.split('?')[1]) && new URLSearchParams(window.location.href.split('?')[1]).get('search-string') ? new URLSearchParams(window.location.href.split('?')[1]).get('search-string') : '';
    private editDataSendEmailModalOpened:boolean=false

    private created() {
        this.changeSpinnerVisibility(true);
        // this.dateRangeSelected(this.defaultDate.from, this.defaultDate.to);
        this.fetchFirstPageList();
        this.fetchInternalBusinessList();
        this.searchSerie = '';
        this.searchInternalBusiness = '';
    }


    @Watch('dateTo')
    private watchDateTo(newVal: string, oldVal: string) {
        if ( newVal !== oldVal && oldVal !== '' ) {
            this.fetchFirstPageList();
        }
    }

    @Watch('dateFrom')
    private watchDateFrom(newVal: string, oldVal: string) {
        if ( newVal !== oldVal && oldVal !== '' ) {
            this.fetchFirstPageList();
        }
    }

    @Watch('searchInternalBusiness')
    private watchInternalBusiness(newVal: string, oldVal: string) {
        if ( newVal !== oldVal ) {
            this.fetchFirstPageList();
        }
    }

    @Watch('searchSerie')
    private watchSerie(newVal: string, oldVal: string) {
        if ( newVal !== oldVal ) {
            this.fetchFirstPageList();
        }
    }

    @Watch('searchFiscalData')
    private watchFiscalData(newVal: string, oldVal: string) {
        if ( newVal !== oldVal ) {
            this.fetchFirstPageList();
        }
    }

    @Watch('searchNifString')
    private watchSearchNifStringBillList(newVal: string, oldVal: string) {
        if (newVal !== oldVal) {
            this.fetchFirstPageList();
        }
    }

    @Watch('transactionTypeSelected')
    private watchTransactionTypeSelected(newVal: any, oldVal: any) {
        if ( newVal !== oldVal ) {
            this.fetchFirstPageList();
        }
    }


    get openModal() {
        return this.editBillModalOpened;
    }

    get showPagination() {
        return this.billListLoaded && !this.spinner.show;
    }

    get showTable() {
        return (this.billListLoaded && !this.spinner.show);
    }

    get dropUpOptions() {
        return [
            { value: ListActions.DownloadCsv, name: 'Exportar CSV' },
            { value: ListActions.DownloadBillZip, name: 'Descargar facturas' },
            { value: ListActions.SendAllBills, name: 'Enviar facturas' },
            { value: ListActions.RegeneratePdf, name: 'Regenerar PDFs' },
        ];
    }

    get showEmptyState() {
        return (this.billListLoaded && !this.spinner.show && this.getBillList.length === 0);
    }

    get defaultDate() {
        const today = dayjs().toISOString();
        const from = dayjs().set('date', 1).set('month', 0).toISOString();
        return {
            from,
            to: today,
        };
    }

    get transactionTypeOptions(): any[] {
        return [
            { id: 0, text: 'Todas las facturas', queryParam: '', value: '' },
            { id: 1, text: 'Emitidas', queryParam: 'transaction_type', value: TransactionType.TransactionEmitted },
            { id: 2, text: 'Recibidas', queryParam: 'transaction_type', value: TransactionType.TransactionReceived },
            { text: 'No enviadas', queryParam: 'communication_status', value: '0' },
            { text: 'Enviadas', queryParam: 'communication_status', value: 1 },
            { text: 'Reenviadas', queryParam: 'communication_status', value: 2 },
            { text: 'Pendientes', queryParam: 'communication_status', value: 3 },
        ];
    }

    get transactionTypeParam() {
        const param: any = {};
        param[this.transactionTypeSelected.queryParam] = this.transactionTypeSelected.value;
        return param;
    }


    public fetchList() {
        this.requestShowSpinner();
        this.changeSpinnerVisibility(true);
        this.fetchBillList((res: any) => {
            this.onFetchSuccess(res);
            this.billListLoaded = true;
            this.changeSpinnerVisibility(false);
        });
    }

    public searchCallback() {
        this.fetchFirstPageList();
    }

    private refetchList() {
        this.fetchList()
        this.fetchFirstPageList();
    }

    public columnOrderFetchList() {
        this.requestShowSpinner();
        this.fetchBillList(
            (res: any) => {
                this.columnOrderOnFetchSuccess();
                this.changeSpinnerVisibility( false );
            },
        );
    }

    private handleComeBack() {
        this.cleanSearch = !this.cleanSearch;
        if (this.searchString === '') {
            this.fetchFirstPageList();
        } else {
            this.searchString = '';
        }
    }

    private fetchBillList( callback: any = () => { const doNothing = 1; } ) {
        const id = this.$route.params.id;
        if (id) {
            this.searchString = id;
        }
        this.$store.dispatch(
            'fetchBillList',
            {
                offset: this.offset,
                limit: this.limit,
                internalBusiness: this.searchInternalBusiness ? this.searchInternalBusiness : '',
                serie: this.searchSerie ? this.searchSerie : '',
                search: this.clientBillsList? this.clientBillsList : this.searchString,
                nif: this.searchNifString,
                fiscalData: this.searchFiscalData,
                dateFrom: this.dateFrom,
                dateTo: this.dateTo,
                ...this.transactionTypeParam,
            },
        ).then(
            (res: any) => {
                this.changeSpinnerVisibility( false );
                callback(res);
            },
            (err: any) => {
                this.changeSpinnerVisibility( false );

            },
        );
    }

    private closeRemittanceModal() {
        this.remittanceModalOpened = false;
    }

    private dropUpOptionSelected(option: any) {
        let transanctionType = this.transactionTypeSelected.id ? this.transactionTypeSelected.id: 0;
        let communicationStatus = !this.transactionTypeSelected.id ? this.transactionTypeSelected.value:undefined;
        if ( transanctionType === 0 ) {
            transanctionType = null;
        }
        let bill_ids = this.getBillList.map((bill:any) => {
            return bill.id;
        })
        switch (option.value) {
            case ListActions.DownloadCsv:
                BillingService.downloadCsv({
                    transanction_type: transanctionType,
                    communication_status: communicationStatus,
                    date_from: this.dateFrom,
                    date_to: this.dateTo,
                    offset: this.offset,
                    limit: this.limit,
                    internalBusiness: this.searchInternalBusiness ? this.searchInternalBusiness : '',
                    serie: this.searchSerie ? this.searchSerie : '',
                    search: this.searchString,
                    fiscalData: this.searchFiscalData,
                    nif: this.searchNifString,
                });
                break;
            case ListActions.DownloadBillZip:
                BillingService.downloadBillZip({
                    transanction_type: transanctionType,
                    date_from: this.dateFrom,
                    date_to: this.dateTo,
                    offset: this.offset,
                    limit: this.limit,
                    internalBusiness: this.searchInternalBusiness ? this.searchInternalBusiness : '',
                    serie: this.searchSerie ? this.searchSerie : '',
                    search: this.searchString,
                    fiscalData: this.searchFiscalData,
                    nif: this.searchNifString,
                }).then(
                    (res) => {
                        const message = res.data.details;
                        this.showMessage({ message });
                    },
                    (err) => {
                        this.showMessage({ error: true, message: err.response.data });
                    },
                );
                break;
            case ListActions.SendAllBills:
                BillingService.sendAllBills({
                    bill_list: bill_ids
                });
                break;
            case ListActions.RegeneratePdf:
                BillingService.regenerateBillPdf({
                    bill_list: bill_ids
                });
                break;
        }
    }

    private editBillDateAndSend(){
        let bill_ids = this.getBillList.map((bill:any) => {
            return bill.id;
        })
        BillingService.editBillDates({
            bill_list: bill_ids
        }).then(
            (res)=>{
                this.showMessage(res.data.details)
                BillingService.sendAllBills({
                    bill_list: bill_ids
                }).then(
                    (res)=>{
                        this.refetchList()
                        this.transactionTypeSelected = this.transactionTypeOptions[0];
                        this.showMessage(res.data.details)
                    }
                );
            }
        );
        this.toggleEditDataSendEmailModalOpened(false)
    }

    private editBillDate(){
        let bill_ids = this.getBillList.map((bill:any) => {
            return bill.id;
        })
        BillingService.editBillDates({
            bill_list: bill_ids, pending: true
        }).then(
            (res)=>{
                this.refetchList()
                this.transactionTypeSelected = this.transactionTypeOptions[0];
                this.showMessage(res.data.details)
            }
        );
        this.toggleEditDataSendEmailModalOpened(false)
    }

    private cleanFilters(){
        // this.searchString = "";
        // this.searchFiscalData = "";
        // // this.dateFrom = "";
        // // this.dateTo = "";
        // this.dateFrom = null;
        // this.dateTo = null;
        // this.defaultDate.from = "";
        // this.defaultDate.to = "";
        // this.searchInternalBusiness = "";
        // this.searchSerie = "";
        // this.defaultDate
        // this.dateRangeSelected(null, null)
        location.reload()
    }

    private setModifyDataPrivate(value: boolean) {
        this.modifyDataPrivateModal = value;
    }
    private setEditBillModalOpened(value: boolean) {
        this.editBillModalOpened = value;
    }

    private dateRangeSelected(from: any, to: any) {
        if (from && to) {
            const dateFrom = UtilsService.setTimeToCero(dayjs(from)).toISOString();
            const dateTo = UtilsService.setTimeToLast(dayjs(to)).toISOString();

            this.dateFrom = dateFrom;
            this.dateTo = dateTo;
        } else {
            this.dateFrom = null;
            this.dateTo = null;
        }
        
    }

    private closingModal() {
        this.modifyDataPrivateModal=false;
        this.setEditBillModalOpened(false);
    }

    private newBillMessage(payload: any) {
        let message = 'Factura añadida con éxito';
        if ( payload.edit ) {
            message = 'Factura editada con éxito';
        }
        this.showMessage(message);
        this.fetchFirstPageList();
    }

    private showMessage(message: any) {
        let color = this.ownSpotlightTextColor.Primary;
        let text = message;
        if ( message.error ) {
            color = this.ownSpotlightTextColor.Error;
        }
        if ( message.message ) {
            text = message.message;
        }
        this.showNotification(text, color);
    }

    private searchStringBill(billToSearch:string){
        this.searchString = billToSearch
    }

    private topBarScrolled(scrolled: boolean) {
        this.alertDisplace = scrolled;
    }

    private fetchInternalBusinessList( callback: any = () => { const doNothing = 1; } ) {
        this.$store.dispatch( 'fetchInternalBusinessList' ).then((res: any) => {
            callback();
            this.showBusiness = true;
        });
    }

    private toggleEditDataSendEmailModalOpened(value: boolean) {
        this.editDataSendEmailModalOpened = value;
    }

}
